var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.permiteBuscar)?_c('b-button',{staticClass:"float-right",attrs:{"variant":"success"},on:{"click":function($event){$event.stopPropagation();return _vm.BuscarDespesa()}}},[_c('span',[_c('i',{staticClass:"fa fa-plus mr-2"}),_vm._v(" Buscar despesa de compra ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }